import { reactive } from 'vue'
import actions from '@/store/referral/actions'
import getters from '@/store/referral/getters'
import state from '@/store/referral/state'

export const referralModule = {
    state: reactive(state),
    actions,
    getters,
}
